import React from "react";
import { Route, RouteProps } from "react-router-dom";
import { Container } from "./styles";

const Layout: React.FC<RouteProps> = ({ children, ...props }) => {
  return (
    <Route {...props}>
      <Container>{children}</Container>
    </Route>
  );
};

export default Layout;
